/**
 * ==============================
 * TECHNOW • Core JS
 * ==============================
 * Règles:
 * - Zéro mutation layout au chargement
 * - Logs activables via localStorage.TECHNOW_DEBUG = "1"
 */

(function () {
  // État global isolé
  const TECHNOW = (window.TECHNOW = window.TECHNOW || {});

  // Empêche un second chargement du même fichier
  if (TECHNOW.__loaded) return;
  TECHNOW.__loaded = true;

  // Debug localStorage: mettre TECHNOW_DEBUG="1" pour activer
  const debug = (typeof localStorage !== 'undefined' && localStorage.getItem('TECHNOW_DEBUG') === '1');
  TECHNOW.env = { ...(TECHNOW.env || {}), debug, version: '0.3.2' };

  const log = (...args) => { if (TECHNOW.env.debug) console.log('[TECHNOW]', ...args); };

  // =============================
  // [technow:FAQ] — helpers (hash + accordéon exclusif + tout fermé par défaut)
  // =============================
  function initTechnowFAQ() {
    // Garde anti-double init
    if (TECHNOW.__faqInit) return;
    TECHNOW.__faqInit = true;

    const roots = document.querySelectorAll('.technow .technow-faq');
    if (!roots.length) return;

    roots.forEach(root => {
      const items = root.querySelectorAll('.technow-faq__item');

      // 1) Tout fermer par défaut (peu importe les attributs)
      items.forEach(d => { d.open = false; });

      // 2) Accordéon exclusif : quand j’en ouvre un, les autres se ferment
      root.addEventListener('click', (e) => {
        const sum = e.target.closest('.technow-faq__summary');
        if (!sum) return;
        const current = sum.parentElement; // <details>
        // Laisse le toggle natif se produire, puis ferme les autres
        setTimeout(() => {
          if (current.open) {
            items.forEach(d => { if (d !== current) d.open = false; });
          }
        }, 0);
      });

      // 3) Ouvrir par hash (#faq-xxx) si présent
      const openByHash = () => {
        if (!location.hash) return;
        const target = root.querySelector(location.hash);
        if (target && target.tagName.toLowerCase() === 'details') {
          // Ferme tout puis ouvre la cible
          items.forEach(d => d.open = false);
          target.open = true;
          try { target.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
          catch (_) { target.scrollIntoView(true); }
        }
      };
      openByHash();
      window.addEventListener('hashchange', openByHash);
    });

    if (TECHNOW.env?.debug) console.log('[TECHNOW][FAQ] init OK');
  }

  console.log('[TECHNOW] JS chargé ✅'); // trace minimale

  document.addEventListener('DOMContentLoaded', () => {
    log('Initialisation');
    initTechnowFAQ(); // [technow:FAQ]
  });
})();

/* =============================
   [technow:MODULE] Title Ticker (Page Visibility)
   ============================= */
(function () {
  // Guard anti double-init (préviews / doubles inclusions)
  const NS = (window.TECHNOW = window.TECHNOW || {});
  if (NS._titleTickerInit) return;
  NS._titleTickerInit = true;

  // Valeurs par défaut (écrasées par la config JSON du <head>)
  const defaults = {
    enabled: true,
    messages: ["🙋‍♂️ Reviens vite !", "⚡ Ton kit 150 BPM t'attend"],
    period: 2000 // ms
  };

  // Lis la config injectée dans le <head>
  try {
    const $cfg = document.getElementById("technow-title-ticker-config");
    if ($cfg && $cfg.textContent) {
      const parsed = JSON.parse($cfg.textContent);
      Object.assign(defaults, parsed || {});
    }
  } catch (e) {
    // silencieux
  }

  // Option: désactiver dans l’éditeur de thème
  if (window.Shopify && Shopify.designMode) {
    defaults.enabled = false;
  }

  const originalTitle = document.title;
  let i = 0;
  let timer = null;

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    // Restaure exactement le titre initial
    document.title = originalTitle;
  }

  function start() {
    if (!defaults.enabled || !defaults.messages || !defaults.messages.length) return;
    if (timer) clearInterval(timer);
    i = 0;
    timer = setInterval(() => {
      document.title = defaults.messages[i % defaults.messages.length];
      i++;
    }, defaults.period);
  }

  function onVisibilityChange() {
    if (document.hidden) start();
    else stop();
  }

  document.addEventListener("visibilitychange", onVisibilityChange, { passive: true });
  window.addEventListener("beforeunload", stop, { passive: true });

  // Petite API console si besoin
  NS.titleTicker = {
    start,
    stop,
    enable(v = true) { defaults.enabled = !!v; if (!v) stop(); },
    setMessages(arr) { if (Array.isArray(arr) && arr.length) defaults.messages = arr; if (document.hidden && timer) start(); },
    setPeriod(ms) { if (typeof ms === "number" && ms >= 300) defaults.period = ms; if (document.hidden && timer) start(); }
  };
})();

// [technow:LOCK-NATIVE] Quantity ownership only. Shopify is the price authority.
(function () {
  'use strict';
  const NS = (window.TECHNOW = window.TECHNOW || {});
  const node = document.getElementById('tnw-lock-config');
  if (!node || NS.lockGift) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (config.enabled !== true) return;
  const marker = 'lock-v1';
  const variant = String(config.giftVariantId || '');
  const kits = new Set((config.kitProductIds || []).filter(Boolean).map(String));
  const root = config.root || '/';
  let running = null;

  function owns(item) {
    return String(item.variant_id) === variant && item.properties?._tnw_gift === marker;
  }
  function previousGiftFlag(item) {
    if (String(item.variant_id) !== variant || owns(item)) return null;
    // Private ownership metadata lets existing carts migrate without an app dependency.
    return Object.keys(item.properties || {}).find(key =>
      key.startsWith('_') && key.endsWith('_free_gift') && String(item.properties[key]) === 'true') || null;
  }
  function kitQuantity(cart) {
    return cart.items.reduce((total, item) => total + (kits.has(String(item.product_id)) ? item.quantity : 0), 0);
  }
  function analyze(cart) {
    if (!Array.isArray(cart?.items)) throw new Error('Impossible de vérifier le panier. Réessaie.');
    const desired = kitQuantity(cart);
    const owned = cart.items.filter(owns);
    const old = cart.items.filter(previousGiftFlag);
    const count = owned.reduce((sum, item) => sum + item.quantity, 0);
    return { desired, owned, old, count };
  }
  function plan(cart) {
    const state = analyze(cart);
    // Adopt only explicitly marked previous gifts, never an unmarked paid LOCK.
    if (state.old.length) {
      const item = state.old[0];
      if (!state.desired) return { kind: 'change', id: item.key, quantity: 0 };
      const previousPrefix = previousGiftFlag(item).slice(0, -'free_gift'.length);
      const properties = Object.fromEntries(Object.entries(item.properties || {}).filter(([key]) => !key.startsWith(previousPrefix)));
      properties._tnw_gift = marker;
      return { kind: 'change', id: item.key, quantity: item.quantity, properties };
    }
    if (state.count > state.desired) {
      // Discount splits are legitimate lines; reduce only the excess, using fresh keys.
      const item = state.owned[state.owned.length - 1];
      return { kind: 'change', id: item.key, quantity: Math.max(0, item.quantity - (state.count - state.desired)) };
    }
    if (state.count < state.desired) {
      const missing = state.desired - state.count;
      if (state.owned.length) {
        const item = state.owned[0];
        return { kind: 'change', id: item.key, quantity: item.quantity + missing };
      }
      return { kind: 'add', items: [{ id: Number(variant), quantity: missing, properties: { _tnw_gift: marker } }] };
    }
    return null;
  }
  function assertDiscount(cart) {
    const state = analyze(cart);
    if (state.old.length || state.count !== state.desired) throw new Error('Le nombre de LOCK offerts n’a pas pu être confirmé. Réessaie.');
    if (!state.desired) return;
    // Native BXGY chooses the discounted line of identical variants. Count the actual
    // free allocation across all LOCK lines; paid extra units remain owned by the buyer.
    const free = cart.items.reduce((sum, item) => {
      if (String(item.variant_id) !== variant || !(item.original_price > 0)) return sum;
      return sum + (item.line_level_discount_allocations || []).reduce((quantity, allocation) => {
        const discount = allocation.discount_application;
        const amount = Number(allocation.amount);
        const units = amount / item.original_price;
        return quantity + (discount?.title === config.discountTitle && discount.value_type === 'percentage' &&
          Number(discount.value) === 100 && Number.isInteger(units) ? units : 0);
      }, 0);
    }, 0);
    if (free !== state.desired) throw new Error('La gratuité du LOCK n’est pas confirmée par Shopify. Vérifie la réduction native avant de poursuivre.');
  }
  async function request(fetcher, path, body, signal) {
    const response = await fetcher(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal,
      headers: { 'Accept': 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const result = await response.json();
    if (!response.ok || Number(result.status) >= 400) {
      const detail = typeof result.description === 'string' ? result.description : result.message;
      throw new Error(detail || 'Le LOCK ne peut pas être ajouté à cette quantité. Réduis la quantité de kits ou contacte-nous.');
    }
    return result;
  }
  async function run(fetcher, signal) {
    if (!variant || !kits.size || !config.discountTitle) throw new Error('La configuration du LOCK offert doit être complétée.');
    let cart = await request(fetcher, 'cart.js', null, signal);
    for (let attempt = 0; attempt < 12; attempt++) {
      const state = analyze(cart);
      if (state.desired && config.giftAvailable !== true) throw new Error('Le LOCK offert est indisponible. Contacte-nous avant de finaliser ton panier.');
      const operation = plan(cart);
      if (!operation) { assertDiscount(cart); return cart; }
      if (operation.kind === 'add') {
        await request(fetcher, 'cart/add.js', { items: operation.items }, signal);
        cart = await request(fetcher, 'cart.js', null, signal);
      } else {
        const { kind, ...body } = operation;
        cart = await request(fetcher, 'cart/change.js', body, signal);
      }
      // Every loop re-reads authoritative quantities and recalculated line keys.
      // An uncertain POST is never retried automatically; manual retry begins with GET.
    }
    throw new Error('Le cadeau n’a pas pu être synchronisé. Réessaie la mise à jour.');
  }
  function sync(fetcher) {
    if (running) return running;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const execute = () => run(fetcher, controller.signal);
    const operation = window.navigator?.locks?.request
      ? window.navigator.locks.request('technow-lock-gift', { mode: 'exclusive', signal: controller.signal }, execute)
      : Promise.resolve().then(execute);
    running = operation.catch(error => {
      if (error.name === 'AbortError') throw new Error('La vérification du cadeau prend trop de temps. Réessaie.');
      throw error;
    }).finally(() => { clearTimeout(timeout); running = null; });
    return running;
  }
  NS.lockGift = { enabled: true, sync, plan, owns, assertDiscount };
})();
// [/technow:LOCK-NATIVE]

// ============================
// [technow:CART-COUNT] — solide (hidden + classe visible + debounce + hook fetch)
// ============================
(function(){
  const NS = (window.TECHNOW = window.TECHNOW || {});
  if (NS.__cartCountInit || (NS.lockGift?.enabled && document.querySelector('#CartDrawer[data-tnw-native-cart]'))) return;
  NS.__cartCountInit = true;

  NS.cartDebounceTimer = NS.cartDebounceTimer || null;

  async function tnwRefreshCartCount() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await r.json();
      const el = document.querySelector('[data-cart-count]');
      if (!el) return;

      // on neutralise tout style inline que quelque chose aurait pu injecter
      el.removeAttribute('style');

      const n = cart.item_count || 0;
      if (n > 0) {
        el.textContent = n;
        el.classList.add('cart-link__bubble--visible');
        el.removeAttribute('hidden');
      } else {
        el.textContent = '';
        el.classList.remove('cart-link__bubble--visible');
        el.setAttribute('hidden', '');
      }
    } catch (e) {/* noop */}
  }
  NS.tnwRefreshCartCount = tnwRefreshCartCount;

  function tnwRefreshCartCountDebounced(delay = 180) {
    clearTimeout(NS.cartDebounceTimer);
    NS.cartDebounceTimer = setTimeout(tnwRefreshCartCount, delay);
  }

  // Événements “maison”
  document.addEventListener('cart:updated', tnwRefreshCartCount);
  document.addEventListener('product:added', tnwRefreshCartCount);

  // Fallback: intercepte /cart/*
  (function(){
    const _fetch = window.fetch;
    window.fetch = function(i, init){
      const url = typeof i === 'string' ? i : (i?.url || '');
      const p = _fetch.apply(this, arguments);
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        p.then(() => tnwRefreshCartCountDebounced()).catch(() => {});
      }
      return p;
    };
  })();

  // Après submit d’un upsell (latence Shopify)
  document.addEventListener('submit', (e)=>{
    if (e.target && e.target.closest('.technow-upsell-card__form')) {
      setTimeout(tnwRefreshCartCount, 120);
      setTimeout(tnwRefreshCartCount, 400);
    }
  });

  // Init
  document.addEventListener('DOMContentLoaded', tnwRefreshCartCount);

  // Si le header est ré-injecté
  document.addEventListener('shopify:section:load', (e) => {
    if (e?.detail?.sectionId && String(e.detail.sectionId).includes('header')) {
      setTimeout(tnwRefreshCartCount, 50);
    }
  });
})();

// ============================
// [technow:UPSELL-BUTTON-RESET]
// Réactive les boutons upsell désactivés
// ============================
(function(){
  const NS = (window.TECHNOW = window.TECHNOW || {});
  if (NS.__upsellButtonResetInit) return;
  NS.__upsellButtonResetInit = true;

  function resetUpsellButtons() {
    document.querySelectorAll('.technow-upsell-card .technow-btn[disabled]').forEach(btn => {
      btn.disabled = false;
      btn.textContent = '+ AJOUTER';
    });
  }

  // Quand le panier est à jour (ton code déclenche déjà ces events)
  document.addEventListener('cart:updated', resetUpsellButtons);
  document.addEventListener('product:added', resetUpsellButtons);

  // Fallback : si un bouton est cliqué et reste bloqué, on le libère après un court délai
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.technow-upsell-card .technow-btn');
    if (!btn) return;
    // On attend 1.5s pour laisser l’app faire son job (ouverture slidecart, etc.)
    setTimeout(() => {
      if (btn.disabled) {
        btn.disabled = false;
        btn.textContent = '+ AJOUTER';
      }
    }, 1500);
  }, { passive: true });
})();

// ============================
// [technow:PRODUCT-TABS] — Ouvrir le 1er onglet réductible
// ============================
(function () {
  const NS = (window.TECHNOW = window.TECHNOW || {});
  if (NS.__openFirstTabInit) return;
  NS.__openFirstTabInit = true;

  function openOnlyFirst(scope) {
    // On ne prend que le 1er wrapper trouvé sur la page/section
    const root = (scope || document).querySelector('.product-block--tab .collapsibles-wrapper');
    if (!root) return;

    // 1er trigger de ce wrapper
    const trigger = root.querySelector('.collapsible-trigger');
    if (!trigger) return;

    // Contenu associé = frère direct (plus sûr) ; fallback sur aria-controls
    let content = trigger.nextElementSibling;
    if (!content || !content.classList || !content.classList.contains('collapsible-content')) {
      const id = trigger.getAttribute('aria-controls');
      if (id) content = document.getElementById(id);
    }
    if (!content) return;

    // Si déjà ouvert, ne rien faire
    if (trigger.classList.contains('is-open') && content.classList.contains('is-open')) return;

    // Ouvre proprement
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    content.classList.add('is-open');

    const hasTransition = getComputedStyle(content).transitionDuration !== '0s';

    // Force une ouverture visible si height est 0/absente, puis passe en auto
    if (!content.style.height || content.style.height === '0px') {
      content.style.height = content.scrollHeight + 'px';
    }

    if (hasTransition) {
      const onEnd = (e) => {
        if (e.propertyName !== 'height') return;
        content.style.height = 'auto';
        content.removeEventListener('transitionend', onEnd);
      };
      content.addEventListener('transitionend', onEnd);
      setTimeout(() => {
        if (content.style.height !== 'auto') content.style.height = 'auto';
      }, 500);
    } else {
      content.style.height = 'auto';
    }
  }

  document.addEventListener('DOMContentLoaded', () => openOnlyFirst());
  document.addEventListener('shopify:section:load', (e) => openOnlyFirst(e.target));
})();
// [technow:NATIVE-CART] Impulse owns opening/focus and product forms; Shopify owns totals.
(function () {
  'use strict';
  const drawer = document.querySelector('#CartDrawer[data-tnw-native-cart]');
  const Theme = window.theme;
  if (!drawer || !Theme?.CartForm || drawer.dataset.tnwCartReady) return;
  drawer.dataset.tnwCartReady = 'true';

  const form = drawer.querySelector('#CartDrawerForm');
  const status = drawer.querySelector('[data-tnw-cart-status]');
  const retry = drawer.querySelector('[data-tnw-cart-retry]');
  const count = drawer.querySelector('[data-tnw-cart-count]');
  const countLabel = drawer.querySelector('[data-tnw-cart-count-label]');
  const giftSync = window.TECHNOW?.lockGift;
  const nativeGifts = giftSync?.enabled === true;
  const pageForm = document.getElementById('CartPageForm');
  const pageStatus = document.querySelector('[data-tnw-lock-page-status]');
  const pageRetry = document.querySelector('[data-tnw-lock-page-retry]');
  let pageCartForm;
  const checkoutApproved = new WeakSet();

  const originalBuild = Theme.CartForm.prototype.buildCart;
  const baseFetch = window.fetch.bind(window);
  let generation = 0;
  let timer = 0;
  let recovery = 0;
  let inFlight = 0;
  let lastMutation = 0;
  let cartForm;
  let busy = false;
  let pending = null;
  let recentAdd = -Infinity;
  let committed = readState(drawer.querySelector('[data-tnw-cart-state]'));
  function readState(node) {
    if (!node) throw new Error('Le panier n’a pas pu être chargé.');
    return { fingerprint: node.dataset.fingerprint, count: Number(node.dataset.count), kits: Number(node.dataset.kits), gifts: Number(node.dataset.gifts) };
  }

  function setBusy(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-tnw-cart-action], [data-tnw-cart-quantity], [data-tnw-cart-upsell]').forEach(control => { control.disabled = value; });
    const checkout = form.querySelector('[name="checkout"]');
    checkout.disabled = value || !committed.count;
    if (nativeGifts && pageForm) pageForm.querySelector('[name="checkout"]').disabled = value || !committed.count;
    if (pageStatus) pageStatus.textContent = value ? 'Vérification du LOCK offert…' : '';
    if (pageRetry) pageRetry.hidden = true;
    if (value) {
      status.textContent = pending?.message || 'Mise à jour de ton panier…';
      retry.hidden = true;
    } else {
      clearPending();
    }
  }

  function clearPending() {
    if (!pending) return;
    pending.item?.removeAttribute('data-tnw-cart-pending');
    pending.feedback?.remove();
    if (pending.button?.isConnected && pending.originalText !== null) pending.button.textContent = pending.originalText;
    pending = null;
  }

  function markPending(item, button, message, label) {
    clearPending();
    if (!item) return;
    item.setAttribute('data-tnw-cart-pending', '');
    const feedback = document.createElement('span');
    feedback.className = 'tnw-cart__activity';
    feedback.setAttribute('aria-hidden', 'true');
    feedback.textContent = label;
    item.querySelector('.tnw-cart__image')?.append(feedback);
    const originalText = button?.hasAttribute('data-tnw-cart-upsell') ? button.textContent : null;
    if (originalText !== null) button.textContent = 'Ajout…';
    pending = { item, button, feedback, message, originalText };
  }

  function fail(error) {
    clearTimeout(timer);
    clearTimeout(recovery);
    generation++;
    setBusy(false);
    // Keep the last confirmed view. A failed reconciliation must never lead to checkout.
    form.querySelector('[name="checkout"]').disabled = true;
    status.textContent = error?.message || 'La mise à jour n’a pas pu être confirmée. Réessaie.';
    retry.hidden = false;
    if (nativeGifts && pageForm) pageForm.querySelector('[name="checkout"]').disabled = true;
    if (pageStatus) pageStatus.textContent = status.textContent;
    if (pageRetry) pageRetry.hidden = false;
  }

  function startUpdate() {
    if (!busy) {
      setBusy(true);
      clearTimeout(recovery);
      recovery = setTimeout(() => fail(new Error('La mise à jour prend plus de temps que prévu. Réessaie.')), 10000);
    }
  }

  function schedule(delay = 60) {
    startUpdate();
    clearTimeout(timer);
    const version = ++generation;
    timer = setTimeout(() => refresh(version), delay);
  }

  async function refresh(version) {
    try {
      if (inFlight) { schedule(120); return; }
      const quietTime = performance.now() - lastMutation;
      if (quietTime < 120) { schedule(120 - quietTime); return; }
      if (nativeGifts) {
        await giftSync.sync(baseFetch);
        if (version !== generation || inFlight) { if (version === generation) schedule(); return false; }
      }

      const url = new URL(Theme.routes.cartPage, location.origin);
      url.searchParams.set('view', 'ajax');
      url.searchParams.set('t', String(Date.now()));
      const response = await baseFetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Impossible de charger le panier. Réessaie.');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (version !== generation) return;
      const content = page.querySelector('template[data-tnw-cart-content]')?.content;
      const next = readState(content?.querySelector('[data-tnw-cart-state]'));
      if (inFlight) { schedule(120); return; }
      if (nativeGifts && pageCartForm) {
        const pageReady = await pageCartForm.buildCart(true);
        if (!pageReady) return false;
        if (version !== generation || inFlight) return false;
      }
      const active = document.activeElement;
      const key = active?.closest('[data-tnw-key]')?.dataset.tnwKey;
      const action = active?.dataset.tnwCartAction;
      const quantityFocused = active?.hasAttribute('data-tnw-cart-quantity');
      const slots = [...content.querySelectorAll('[data-tnw-cart-slot]')];
      if (slots.length !== 4) throw new Error('Le panier n’a pas pu être chargé.');
      // All fragments originate from one Shopify snapshot, including discounts and totals.
      slots.forEach(slot => {
        const destination = drawer.querySelector('[data-tnw-cart-slot="' + slot.dataset.tnwCartSlot + '"]');
        destination.replaceChildren(...slot.childNodes);
      });
      drawer.querySelector('[data-tnw-cart-state]').replaceWith(content.querySelector('[data-tnw-cart-state]'));
      committed = next;
      if (count) count.textContent = String(next.count);
      if (countLabel) countLabel.textContent = next.count + (next.count === 1 ? ' article' : ' articles');
      drawer.classList.toggle('is-empty', !next.count);
      cartForm?.updateCount(next.count);
      if (nativeGifts) document.querySelectorAll('[data-cart-count]').forEach(bubble => {
        bubble.textContent = next.count ? String(next.count) : '';
        bubble.toggleAttribute('hidden', !next.count);
        bubble.classList.toggle('cart-link__bubble--visible', next.count > 0);
      });
      if (cartForm) cartForm.cartItemsUpdated = false;
      clearTimeout(recovery);
      setBusy(false);
      status.textContent = '';
      retry.hidden = true;
      if (key) {
        const item = [...drawer.querySelectorAll('[data-tnw-key]')].find(node => node.dataset.tnwKey === key);
        const control = quantityFocused ? item?.querySelector('[data-tnw-cart-quantity]') : item?.querySelector('[data-tnw-cart-action="' + action + '"]');
        (control || drawer.querySelector('.tnw-cart__close')).focus({ preventScroll: true });
      }
      document.dispatchEvent(new CustomEvent('tnw:cart:rendered', { detail: { count: next.count } }));
      return true;
    } catch (error) {
      if (version === generation) fail(error);
      return false;
    }
  }

  Theme.CartForm.prototype.buildCart = function (giftSettled) {
    if (nativeGifts && this.form === pageForm) {
      pageCartForm = this;
      return (giftSettled === true ? Promise.resolve() : giftSync.sync(baseFetch))
        .then(() => Theme.cart.getCartProductMarkup())
        .then(text => { this.cartMarkup(text); this.cartItemsUpdated = false; return true; })
        .catch(error => { fail(error); return false; });
    }
    if (this.form !== form) return originalBuild.apply(this, arguments);
    cartForm = this;
    schedule();
  };

  // Observe existing native/app mutations without consuming responses or replacing their bodies.
  // Product forms and other integrations keep their original fetch chain.
  window.fetch = function (input, options) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.href);
    const method = String(options?.method || input?.method || 'GET').toUpperCase();
    const mutation = url.origin === location.origin && method === 'POST' && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
    if (!mutation) return baseFetch(input, options);
    inFlight++;
    lastMutation = performance.now();
    startUpdate();
    return baseFetch(input, options).then(response => {
      inFlight--;
      lastMutation = performance.now();
      if (response.ok && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname) && performance.now() - recentAdd < 5000) {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
      schedule();
      return response;
    }, error => {
      inFlight--;
      lastMutation = performance.now();
      schedule();
      throw error;
    });
  };

  async function mutate(url, body) {
    startUpdate();
    const response = await fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : result.message || 'Cet article ne peut pas être mis à jour.');
    schedule();
    return result;
  }

  async function changeQuantity(item, quantity, button) {
    if (busy || !item || !Number.isInteger(quantity) || quantity < 0) return;
    const removing = quantity === 0;
    markPending(item, button, removing ? 'Suppression de ton article…' : 'Mise à jour de la quantité…', removing ? 'Suppression…' : 'Mise à jour…');
    try { await mutate(Theme.routes.cartChange, { id: item.dataset.tnwKey, quantity }); }
    catch (error) { fail(error); }
  }

  drawer.addEventListener('click', async event => {
    const button = event.target.closest('[data-tnw-cart-action], [data-tnw-cart-upsell]');
    if (!button || busy) return;
    if (button.hasAttribute('data-tnw-cart-upsell')) {
      markPending(button.closest('.tnw-cart__upsell-card'), button, 'Ajout de ton article…', 'Ajout…');
      try {
        const product = await mutate(Theme.routes.cartAdd, { id: Number(button.dataset.tnwCartUpsell), quantity: 1 });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product, addToCartBtn: button } }));
      } catch (error) { fail(error); }
      return;
    }
    const item = button.closest('[data-tnw-key]');
    const current = Number(item.querySelector('[data-tnw-cart-quantity]').value);
    const action = button.dataset.tnwCartAction;
    const quantity = action === 'remove' ? 0 : Math.max(0, current + (action === 'plus' ? 1 : -1));
    changeQuantity(item, quantity, button);
  });

  drawer.addEventListener('change', event => {
    if (!event.target.matches('[data-tnw-cart-quantity]')) return;
    const quantity = Number(event.target.value);
    if (!event.target.value.trim() || !Number.isInteger(quantity) || quantity < 0) {
      event.target.value = event.target.defaultValue;
      status.textContent = 'Choisis une quantité entière à partir de zéro.';
      return;
    }
    changeQuantity(event.target.closest('[data-tnw-key]'), quantity);
  });
  function checkout(event) {
    const target = event.currentTarget;
    if (checkoutApproved.has(target)) { checkoutApproved.delete(target); return; }
    if (busy || !committed.count || !retry.hidden) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (!nativeGifts) return;
    // A fresh Shopify snapshot confirms the gift before any form can reach checkout.
    event.preventDefault();
    event.stopImmediatePropagation();
    const submitter = event.submitter || target.querySelector('[name="checkout"]');
    startUpdate();
    clearTimeout(timer);
    refresh(++generation).then(ready => {
      if (!ready || busy || !retry.hidden) return;
      checkoutApproved.add(target);
      target.requestSubmit(submitter);
    });
  }
  form.addEventListener('submit', checkout, true);
  if (nativeGifts && pageForm) pageForm.addEventListener('submit', checkout, true);
  retry.addEventListener('click', () => schedule(0));
  if (nativeGifts) {
    pageRetry?.addEventListener('click', () => schedule(0));
    document.addEventListener('ajaxProduct:added', () => schedule());
    document.addEventListener('cart:updated', () => schedule());
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
    if (pageForm) {
      const registerPage = () => document.dispatchEvent(new CustomEvent('cart:build'));
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', registerPage, { once: true });
      else registerPage();
    }
  }

  document.addEventListener('click', event => {
    if (event.target.closest('[data-add-to-cart], .qsc2-stickybar__action-btn, .technow-upsell-card__form button')) recentAdd = performance.now();
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('form[action*="/cart/add"]')) recentAdd = performance.now();
  }, true);
  document.addEventListener('drawerOpen.CartDrawer', () => { drawer.setAttribute('aria-hidden', 'false'); schedule(); });
  // Impulse changes the open class for close, escape and outside clicks alike.
  const openObserver = new MutationObserver(() => drawer.setAttribute('aria-hidden', String(!drawer.classList.contains('drawer--is-open'))));
  openObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
  window.addEventListener('pagehide', () => { clearTimeout(timer); clearTimeout(recovery); generation++; });
  // Also refresh when theme.js created the initial CartForm before this deferred bundle.
  schedule();
})();
